export const inventoryCountURL = (
  systemCustomerId: string,
  countId: string | number | undefined
) => {
  const apiURL = `/API/Account/${systemCustomerId}/InventoryCount/${countId}/Import.json`;
  return apiURL;
};

export const downloadImportTemplateURL = (systemCustomerId: string | number) => {
  const apiURL = `/API/Account/${systemCustomerId}/InventoryCount/Import/TemplateCsv`;
  return apiURL;
};

export const downloadImportErrorFileURL = (
  systemCustomerId: string,
  countId: string | number | undefined
) => {
  const apiURL = `/API/Account/${systemCustomerId}/InventoryCount/${countId}/Import/ValidationErrors.json`;
  return apiURL;
};
